class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.delay = this.dataset.delay * 1000;
    this.closed = getCookie('newsletter-closed');
    this.subscribed = getCookie('newsletter-subscribed');
    this.form = this.querySelector('.js-form');

    if (this.form) {
      this.form.addEventListener('submit', this.onSubscribe.bind(this));
    }
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === 'true') {
        this.show();
      }
      return;
    }

    // Don't show if already closed or subscribed
    if (this.closed || this.subscribed) return;

    this.ageVerificationPopup = document.querySelector('age-verification-popup:not([disabled])');

    if (this.ageVerificationPopup) {
      var newsletterPopup = this;
      var prevClassState = this.classList.contains('newsletter-popup-is-hidden');

      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName == 'class') {
            var currentClassState = mutation.target.classList.contains('newsletter-popup-is-hidden');
            if (prevClassState !== currentClassState) {
              prevClassState = currentClassState;
              if (!currentClassState) {
                setTimeout(function() {
                  newsletterPopup.show();
                }, newsletterPopup.delay);
              }
            }
          }
        });
      });

      observer.observe(this, { attributes: true });
    } else {
      var self = this;
      setTimeout(function() {
        self.show();
      }, self.delay);
    }
  }

  hide() {
    super.hide();
    setCookie('newsletter-closed', 'true', 30);
  }

  showConfirmation() {
    var wrapper = this.querySelector('.newsletter-popup__wrapper');
    var self = this;
    wrapper.innerHTML = '';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.textContent = 'X';
    closeBtn.setAttribute('style', 'display:block;margin:16px 16px 0 auto;background:none;border:none;cursor:pointer;font-size:20px;color:inherit;');
    closeBtn.addEventListener('click', function() { self.hide(); });

    var heading = document.createElement('h2');
    heading.textContent = 'welcome to the group chat';
    heading.setAttribute('style', 'text-align:center;margin:24px 24px 8px;font-size:1.4rem;');

    var message = document.createElement('p');
    message.textContent = 'CHECK YOUR EMAIL FOR THE CODE!';
    message.setAttribute('style', 'padding:16px 32px 40px;text-align:center;font-size:1rem;font-weight:bold;letter-spacing:0.05em;margin:0;');

    wrapper.appendChild(closeBtn);
    wrapper.appendChild(heading);
    wrapper.appendChild(message);
  }

  onSubscribe(event) {
    event.preventDefault();
    var form = event.target;
    var formData = new FormData(form);
    var self = this;

    fetch(form.action, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new URLSearchParams(formData).toString()
    }).then(function(response) {
      setCookie('newsletter-subscribed', 'true', 365);
      self.showConfirmation();
    }).catch(function() {
      setCookie('newsletter-subscribed', 'true', 365);
      self.showConfirmation();
    });
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
